import { AbstractControl } from '@angular/forms';

export function ValidateWhiteSpace(control: AbstractControl) {
    if (control.value != null) {
        if ((control.value).trim() === '' && control.value !== '') {
            return { whiteSpace: true };
        }
    } else {
        return null;
    }
}
